import React from "react";
import Loading from "../../Loder";
const BasicDetails = React.lazy(() => import("./BasicDetails"));
const FavouriteJobs = React.lazy(() => import("./FavouriteJobs"));
const ReferFriend = React.lazy(() => import("./ReferFriend"));
const PasswordsManagement = React.lazy(() => import("./PasswordsManagement"));
const Availability = React.lazy(()=> import("./Availability"));

const TabContentSection = React.memo(function TabContentSection({ keyName, user }) {
  return (
    <div>
      {keyName === "Basicdetails" && (
        <React.Suspense fallback={<Loading />}>
          <BasicDetails />
        </React.Suspense>
      )}

      {keyName === "FaviouteJobs" && (
        <React.Suspense fallback={<Loading />}>
          <FavouriteJobs />
        </React.Suspense>
      )}

      {keyName === "ReferFriend" && (
        <React.Suspense fallback={<Loading />}>
          <ReferFriend />
        </React.Suspense>
      )}

      {(user?.candidateAvailability?.visible && user?.candidateAvailability?.enabled && user?.resumeID)&& (
        <>
          {keyName == "Availability" && (
            <React.Suspense fallback={<Loading />}>
              <Availability />
            </React.Suspense>
          )}
        </>
      )}

      {keyName === "Passwords" && (
        <React.Suspense fallback={<Loading />}>
          <PasswordsManagement />
        </React.Suspense>
      )}
    </div>
  );
});

export default TabContentSection;